import apiFetch from '../apiFetch'

export default function (dossierServiceId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossierService/${dossierServiceId}`, method: 'DELETE', token: token, lastAccessDate })
}
